import { useSelectedNode } from "./useSelectedNode";
export var useSelectedNodeAnswer = function useSelectedNodeAnswer() {
  var _useSelectedNode = useSelectedNode(),
    level1Node = _useSelectedNode.level1Node,
    level2Node = _useSelectedNode.level2Node,
    level3Node = _useSelectedNode.level3Node,
    level4Node = _useSelectedNode.level4Node,
    level5Node = _useSelectedNode.level5Node;
  var finalNode = level5Node || level4Node || level3Node || level2Node || level1Node;
  if (!finalNode) {
    return EMPTY_ANSWER();
  }
  var instantAnswer = finalNode.instantAnswer,
    _finalNode$articles = finalNode.articles,
    helpArticles = _finalNode$articles === void 0 ? [] : _finalNode$articles;
  return {
    hasInstantAnswer: !!instantAnswer,
    instantAnswer: instantAnswer,
    helpArticles: helpArticles,
    hasHelpArticles: helpArticles.length > 0
  };
};
var EMPTY_ANSWER = function EMPTY_ANSWER() {
  return {
    hasInstantAnswer: false,
    instantAnswer: undefined,
    helpArticles: [],
    hasHelpArticles: false
  };
};